import React, { useState, useEffect, useCallback } from 'react';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import useColumnResize from '../../hooks/useColumnResize';
import useTablePagination from '../../hooks/useTablePagination';
import ReadyFilters, { useReadyFilters } from '../../components/ReadyFilters';

const toFa = n => n===null||n===undefined?'':String(n).replace(/[0-9]/g,d=>'۰۱۲۳۴۵۶۷۸۹'[d]);
const toEng = s => String(s).replace(/[۰-۹]/g,d=>'۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());
const numFmt = n => { const v=Math.abs(n||0); return v ? v.toLocaleString('fa-IR') : '•'; };
const si = v => { try{return parseInt(toEng(String(v||0)),10)||0;}catch{return 0;} };

/* فراخوانی API + رفرش توکن */
async function API(path,opts={}){
  const doFetch=()=>fetch(`/api/accounting${path}`,{headers:{'Content-Type':'application/json',Authorization:`Bearer ${localStorage.getItem('access')}`},...opts});
  let res=await doFetch();
  if(res.status===401){const rr=await fetch('/api/auth/token/refresh/',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({refresh:localStorage.getItem('refresh')})});if(rr.ok){const d=await rr.json();localStorage.setItem('access',d.access);res=await doFetch();}}
  return res.json();
}

export default function ContractorRequestReadyModal({ year, onClose, onAdded }) {
  const [rawRows,  setRawRows]  = useState([]);
  const [selected, setSelected] = useState(null);
  const [readyNo,  setReadyNo]  = useState('');
  const [docDate,  setDocDate]  = useState('');
  const [serverTotal, setServerTotal] = useState(0);
  const [serverHasMore, setServerHasMore] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading,  setLoading]  = useState(false);
  const [saving,   setSaving]   = useState(false);
  const [error,    setError]    = useState('');
  const [toast,    setToast]    = useState('');
  // فیلترهای همزمان: جستجو + هزینه‌ای/تملک + سال مالی (سمت سرور)
  const f = useReadyFilters({ initialFy: year });

  // عرض ستون‌ها
  const { widths, TH } = useColumnResize([50,70,130,120,55,55,90,75,75,80,75,75,90,70,70,60,65]);

  const {
    visibleRows,
    shownCount, LoadMoreButton,
  } = useTablePagination({
    allRows: rawRows, pageSize: 200,
    searchFields: [],   // جستجو سمت سرور انجام می‌شود
      serverTotal,
    serverHasMore,
  });

  const showToast = msg => { setToast(msg); setTimeout(()=>setToast(''),4000); };

  useEffect(() => {
    API(`/documents/next-no/?year=${year}`).then(j => { if (j.ok) setDocDate(j.last_date||''); });
  }, [year]);

  /* خواندن فهرست از سرور */
  const load = useCallback(async () => {
    setLoading(true); setError(''); setRawRows([]); setSelected(null);
    const j = await API(`/auto-document/contractor-request/ready/?page=1${f.query ? '&'+f.query : ''}`);
    setLoading(false);
    if (j.ok) { setRawRows(j.data); setServerTotal(j.total||j.count||0); setServerHasMore(j.has_more||false); setCurrentPage(1); } else setError(j.msg);
  }, [f.query]);

  /* ۲۰۰ ردیف بعدی */
  const loadMore = async () => {
    const nextPage = currentPage + 1;
    setLoadingMore(true);
    const j = await API(`/auto-document/contractor-request/ready/?page=${nextPage}${f.query ? '&'+f.query : ''}`);
    setLoadingMore(false);
    if (j.ok) {
      setRawRows(prev => [...prev, ...j.data]);
      setServerTotal(j.total||0);
      setServerHasMore(j.has_more||false);
      setCurrentPage(nextPage);
    }
  };

  useEffect(() => { load(); }, [load]);

  const sel = selected ? rawRows.find(r => r.contractor_request_id === selected) : null;
  const isNewDoc = si(readyNo) === 0;

  /* افزودن به سند */
  const addToDoc = async () => {
    if (!sel) { setError('صورت وضعیتی انتخاب نشده'); return; }
    if (isNewDoc && !docDate) { setError('تاریخ سند جدید الزامیست'); return; }
    setSaving(true); setError('');
    const j = await API('/auto-document/contractor-request/add/', {
      method:'POST',
      body: JSON.stringify({ financial_year:year, ready_document_no:si(readyNo), doc_date:docDate, row:sel }),
    });
    setSaving(false);
    if (j.ok) { showToast(j.msg); onAdded&&onAdded(); load(); } else setError(j.msg);
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={e=>e.stopPropagation()}>
        <div style={s.hdr}>
          <div>
            <div style={{fontSize:'15px',fontWeight:'700',color:'#fff'}}>📝 صورت وضعیت — شناسایی صورت وضعیت</div>
            <div style={{fontSize:'11px',color:'rgba(255,255,255,0.6)',marginTop:'2px'}}>
              حساب‌های ۶۱۰/۱۵۰/۲۱۰/۲۴۰/۸۱۰/۸۲۰ — سال مالی {toFa(year)}
            </div>
          </div>
          <button onClick={onClose} style={s.xBtn}>✕</button>
        </div>
        <div style={s.body}>
          {error && <div style={s.err}>⚠️ {error}</div>}

          <div style={{...s.card, background:'#fffdf5', border:'1.5px solid #f0e6c0'}}>
            <div style={{fontSize:'12px',fontWeight:'700',color:'#8d6e00',marginBottom:'8px'}}>🧾 سند مقصد</div>
            <div style={{display:'flex',gap:'14px',flexWrap:'wrap',alignItems:'flex-end'}}>
              <div style={s.fld}>
                <label style={s.lbl}>شماره سند مقصد</label>
                <input value={toFa(readyNo)} onChange={e=>setReadyNo(toEng(e.target.value).replace(/\D/g,'').slice(0,6))}
                  placeholder="خالی = سند جدید" style={{...s.inp,width:'150px'}} />
              </div>
              {isNewDoc && (
                <div style={s.fld}>
                  <label style={s.lbl}>تاریخ سند جدید *</label>
                  <JalaliDatePicker value={docDate} onChange={v=>setDocDate(v)} placeholder="تاریخ"/>
                </div>
              )}
              <div style={{fontSize:'11px',color:'#555',flex:1,minWidth:'200px'}}>⚠ تک‌انتخابی — هر بار فقط یک صورت وضعیت</div>
            </div>
          </div>

          <ReadyFilters f={f}
            searchLabel="جستجو (سریال / شماره / قرارداد / پیمانکار / شرح / نامه)">
            <button onClick={load} disabled={loading} style={s.btnS}>{loading?'⏳...':'↺ به‌روزرسانی'}</button>
            <span style={{fontSize:'11px',color:'#888'}}>{toFa(shownCount)} از {toFa(serverTotal)}</span>
          </ReadyFilters>

          <div style={{flex:1,overflow:'auto',borderRadius:'8px',boxShadow:'0 1px 6px rgba(0,0,0,0.1)'}}>
            <table style={{width:'100%',borderCollapse:'collapse',direction:'rtl',fontSize:'11px',tableLayout:'fixed'}}>
              {/* سرستون‌ها */}
              <thead>
                <tr>
                  <TH idx={0}>سریال</TH>
                  <TH idx={1}>نوع قرارداد</TH>
                  <TH idx={2} right>قرارداد</TH>
                  <TH idx={3} right>پیمانکار</TH>
                  <TH idx={4}>نوع</TH>
                  <TH idx={5}>شماره</TH>
                  <TH idx={6} red>مبلغ کارکرد</TH>
                  <TH idx={7}>بیمه سهم دولت</TH>
                  <TH idx={8}>مالیات</TH>
                  <TH idx={9}>بیمه پیمانکار</TH>
                  <TH idx={10}>سپرده</TH>
                  <TH idx={11}>سایر کسور</TH>
                  <TH idx={12} red>خالص پیمانکار</TH>
                  <TH idx={13}>از تاریخ</TH>
                  <TH idx={14}>تا تاریخ</TH>
                  <TH idx={15}>نامه</TH>
                  <TH idx={16}>نوع حساب</TH>
                </tr>
              </thead>
              <tbody>
                {visibleRows.map((r,i)=>{
                  const isSel = selected === r.contractor_request_id;
                  return (
                  <tr key={r.contractor_request_id} onClick={()=>setSelected(isSel?null:r.contractor_request_id)}
                    style={{background:isSel?'#e8f5e9':i%2===0?'#fff':'#fafafa',cursor:'pointer'}}>
                    <td style={s.td}>{toFa(r.serial_no)}</td>
                    <td style={{...s.td,fontSize:'9px'}}>{r.contract_type||'—'}</td>
                    <td style={{...s.td,textAlign:'right',fontSize:'10px'}} title={r.contract_display}>{r.contract_display||'—'}</td>
                    <td style={{...s.td,textAlign:'right'}}>{r.contractor_name}</td>
                    <td style={{...s.td,fontSize:'9px'}}>{r.request_type===0?'عادی':'قطعی'}</td>
                    <td style={s.td}>{r.request_no}</td>
                    <td style={{...s.td,fontFamily:'monospace',fontWeight:'700',color:'#b71c1c'}}>{numFmt(r.request_amount)}</td>
                    <td style={{...s.td,fontFamily:'monospace',color:'#1565c0'}}>{numFmt(r.insure_amount)}</td>
                    <td style={{...s.td,fontFamily:'monospace',color:'#e65100'}}>{numFmt(r.tax_amount)}</td>
                    <td style={{...s.td,fontFamily:'monospace',color:'#4a148c'}}>{numFmt(r.insure_contractor_amount)}</td>
                    <td style={{...s.td,fontFamily:'monospace',color:'#1b5e20'}}>{numFmt(r.deposit_amount)}</td>
                    <td style={{...s.td,fontFamily:'monospace',color:'#795548'}}>{numFmt(r.other_deduction_amount)}</td>
                    <td style={{...s.td,fontFamily:'monospace',fontWeight:'700',color:'#b71c1c'}}>{numFmt(r.net_pay)}</td>
                    <td style={{...s.td,fontFamily:'monospace',fontSize:'10px'}}>{r.from_date||'—'}</td>
                    <td style={{...s.td,fontFamily:'monospace',fontSize:'10px'}}>{r.to_date||'—'}</td>
                    <td style={{...s.td,fontSize:'10px'}}>{r.letter_no||'—'}</td>
                    <td style={{...s.td,fontSize:'10px',color:r.credit_info===1?'#1565c0':'#4a148c'}}>
                      {r.credit_info===1?'هزینه ای':r.credit_info===2?'تملک':'—'}</td>
                  </tr>);})}
                {!loading && visibleRows.length===0 && (
                  <tr><td colSpan={17} style={{...s.td,padding:'24px',color:'#999'}}>📭 صورت وضعیت ثبت‌نشده‌ای وجود ندارد</td></tr>
                )}
              </tbody>
            </table>
          </div>

          <LoadMoreButton onClick={loadMore} loading={loadingMore} />

          <div style={{display:'flex',alignItems:'center',gap:'8px',flexWrap:'wrap',flexShrink:0}}>
            {sel && <>
              <span style={s.badge('#1a2f50')}>{fa("سریال")} {toFa(sel.serial_no)}</span>
              <span style={s.badge('#b71c1c')}>{fa("کارکرد")}: {numFmt(sel.request_amount)}</span>
              <span style={s.badge('#1b5e20')}>{fa("خالص")}: {numFmt(sel.net_pay)}</span>
            </>}
            <button onClick={addToDoc} disabled={saving||!sel}
              style={{...s.btnP,marginRight:'auto',opacity:(saving||!sel)?0.4:1}}>
              {saving?'⏳...':(isNewDoc?'💾 ساخت سند شناسایی':'💾 افزودن به سند')}
            </button>
          </div>
        </div>
        {toast && <div style={{position:'absolute',bottom:'14px',right:'14px',background:'#1b5e20',
          color:'#fff',padding:'10px 20px',borderRadius:'8px',fontSize:'13px',fontWeight:'600',zIndex:10}}>{toast}</div>}
      </div>
    </div>
  );
}

const fa = t => t;
/* استایل‌ها */
const s = {
  overlay:   {position:'fixed',inset:0,background:'rgba(0,0,0,0.65)',zIndex:3000,display:'flex',alignItems:'center',justifyContent:'center',padding:'12px'},
  modal:     {background:'#f0f2f7',borderRadius:'14px',width:'100%',maxWidth:'1300px',maxHeight:'90vh',display:'flex',flexDirection:'column',boxShadow:'0 24px 64px rgba(0,0,0,0.5)',overflow:'hidden',position:'relative'},
  hdr:       {display:'flex',justifyContent:'space-between',alignItems:'flex-start',padding:'14px 18px',background:'linear-gradient(135deg,#0a1628,#1565c0)',flexShrink:0},
  xBtn:      {background:'rgba(255,255,255,0.15)',border:'1px solid rgba(255,255,255,0.3)',color:'#fff',width:'28px',height:'28px',borderRadius:'50%',cursor:'pointer',fontSize:'12px',display:'flex',alignItems:'center',justifyContent:'center'},
  body:      {flex:1,overflowY:'auto',padding:'14px',display:'flex',flexDirection:'column',gap:'10px'},
  err:       {background:'#fff3f3',border:'1px solid #ffcdd2',borderRadius:'7px',padding:'8px 12px',color:'#c62828',fontSize:'12px'},
  card:      {background:'#fff',borderRadius:'10px',padding:'14px',boxShadow:'0 1px 4px rgba(0,0,0,0.08)'},
  fld:       {display:'flex',flexDirection:'column',gap:'3px'},
  lbl:       {fontSize:'11px',fontWeight:'600',color:'#555'},
  inp:       {padding:'7px 10px',border:'1.5px solid #e0e0e0',borderRadius:'7px',fontSize:'12px',fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',direction:'rtl',textAlign:'right',boxSizing:'border-box'},
  td:        {padding:'5px 8px',fontSize:'11px',textAlign:'center',borderBottom:'1px solid #f0f0f0',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},
  btnP:      {padding:'9px 20px',background:'linear-gradient(135deg,#1565c0,#1976d2)',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px',fontWeight:'700'},
  btnS:      {padding:'8px 14px',background:'#e0e0e0',color:'#333',border:'none',borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'12px'},
  badge:     bg => ({padding:'4px 10px',background:bg,color:'#fff',borderRadius:'16px',fontSize:'11px',fontWeight:'700'}),
};